<template>
  <v-rating
    v-model="inputValue"
    background-color="orange darken-2"
    color="orange darken-2"
    length="5"
    hover
    :dense="$vuetify.breakpoint.xsOnly"
  ></v-rating>
</template>

<script>
export default {
  name: "ratingCard",
  props: ["value"],
  methods: {},
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style>
.v-icon.mdi {
  font-size: 20px !important;
}
</style>
